import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-800 text-white">
      {/* Curved Section */}
      <div className="bg-gray-900 py-12">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-8">
          {/* Left Section */}
          <div>
            <h2 className="text-yellow-400 text-lg font-bold mb-4">
              Taxica India
            </h2>
            <p className="text-gray-400">
              Taxica India : Safe, reliable, and affordable taxi travel across
              India. Simplifying journeys since our founding by Miss Ruchika
              Shirvastav.
            </p>
            {/* <p className="mt-4">
              <span className="text-yellow-400 font-bold">
                Toll Free Helpline
              </span>
              : (+1) 123 4567 890
            </p> */}
          </div>

          {/* Useful Links */}
          <div>
            <h2 className="text-white text-lg font-bold mb-4">Useful Links</h2>
            <ul className="space-y-2 text-gray-400">
              <li>
                <span onClick={()=>navigate("/AboutUs")} className="hover:text-yellow-400 cursor-pointer">
                  About
                </span>
              </li>
              <li >
                <span onClick={()=> navigate("/TermsAndConditions")} className="hover:text-yellow-400 cursor-pointer">
                  Terms And Conditions
                </span>
              </li>
              <li>
                <span onClick={()=>navigate("/PrivacyPolicy")} className="hover:text-yellow-400 cursor-pointer">
                  Privacy & Policy
                </span>
              </li>
              {/* <li>
                <a href="#" className="hover:text-yellow-400">
                  Our Vehicles
                </a>
              </li> */}
              {/* <li>
                <a href="#" className="hover:text-yellow-400">
                  Services
                </a>
              </li> */}
              {/* <li>
                <a href="#" className="hover:text-yellow-400">
                  Packages
                </a>
              </li> */}
              {/* <li>
                <a href="#" className="hover:text-yellow-400">
                  Login
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-yellow-400">
                  Register
                </a>
              </li> */}
              {/* <li>
                <a href="#" className="hover:text-yellow-400">
                  Latest News
                </a>
              </li> */}
            </ul>
          </div>

          {/* Head Office */}
          <div>
            <h2 className="text-white text-lg font-bold mb-4">Office</h2>
            <p className="text-gray-400">
              9/11, Mitralok Colony, Saiyidwala, Khurbura Mohalla, Dehradun,
              Uttarakhand 248001
            </p>
            <p className="mt-2 text-gray-400">
              Phone: (+91) 757 9126 007 <br />
              Email:{" "}
              <a
                href="mailto:Carrgo@gmail.com"
                className="text-yellow-400 hover:underline"
              >
                taxicaindia@gmail.com
              </a>{" "}
            </p>
          </div>

          {/* Download App Section */}
          <div>
            <h2 className="text-white text-lg font-bold mb-4">
              Download Mobile App
            </h2>
            <div className="flex space-x-4">
              <img
                src="https://carrgohtml.tortoizthemes.com/assets/images/icon/google-play.webp"
                alt="Google Play"
                className="hover:opacity-80 rounded-lg"
              />
              {/* <img
                src="https://carrgohtml.tortoizthemes.com/assets/images/icon/apple-store.webp"
                alt="App Store"
                className="hover:opacity-80 rounded-lg"
              /> */}
            </div>
            <div className="mt-6 space-y-4">
              <a
                href="#"
                className="bg-yellow-400 text-gray-800 px-6 py-2 block text-center font-bold rounded-full hover:bg-gray-800 hover:text-yellow-400 transition duration-300"
              >
                BECOME A DRIVER
              </a>
              <a
                href="#"
                className="border-2 border-yellow-400 text-yellow-400 px-6 py-2 block text-center font-bold rounded-full hover:bg-yellow-400 hover:text-gray-800 transition duration-300"
              >
                RIDE WITH TAXICA
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-gray-900 py-4">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center text-gray-400 text-sm">
          <p>© Copyright 2025 by Taxica India. All Rights Reserved.</p>
          {/* <div className="flex space-x-4">
            <a href="#" className="hover:text-yellow-400">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" className="hover:text-yellow-400">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="hover:text-yellow-400">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="hover:text-yellow-400">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="#" className="hover:text-yellow-400">
              <i className="fab fa-pinterest"></i>
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
